import { render, staticRenderFns } from "./Verka-Alert.vue?vue&type=template&id=0a7192c9&scoped=true&"
import script from "./Verka-Alert.vue?vue&type=script&lang=ts&"
export * from "./Verka-Alert.vue?vue&type=script&lang=ts&"
import style0 from "./Verka-Alert.vue?vue&type=style&index=0&id=0a7192c9&scoped=true&land=ts&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7192c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VRow})
